import React from 'react';

const AppContext = React.createContext('app');

export default AppContext;
